import React, { Component } from 'react';
import './Deals.css';
import {DealItem} from './DealItem'
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl , limitText } from "../../Utility/Utility"


class Deals extends Component {
  
  constructor (props){
  	super(props);
  	this.image_url = getImgUrl();
  	
  	this.dealsSliderSettings = {
      	dots: true,
      	infinite: true,
      	cssEase: 'linear',
      	autoplay:false,
      	lazyLoad: "ondemand",
      	slidesToShow: (this.props.items != undefined  ) ? this.props.items : 3,
		slidesToScroll: 1,
		responsive: [
	        {
	          breakpoint: 1000,
	          settings: {
	            slidesToShow: 2,
	            slidesToScroll: 2
	          }
	        },
	        {
	          breakpoint: 600,
	          settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1
	          }
	        }
      	]
    };

  	  	this.deals = [


			{
		      title: "NORWEGIAN",
		      desc :"VUELOS A TEL AVIV",
		      price : "199€",
		      logo :"/Deals/norwegian.png",
		      link :"https://www.norwegian.com/reserva/reserve-su-vuelo/preciosbaratos/?A_City=TLV&AdultCount=1&ChildCount=0&CurrencyCode=EUR&D_City=BCN&D_Day=06&D_Month=202002&D_SelectedDay=06&IncludeTransit=true&InfantCount=0&R_Day=06&R_Month=202002&R_SelectedDay=06&TripType=2#/?origin=BCN&destination=TLV&outbound=2020-02&inbound=2020-02&selectedInbound=2020-02-09&adults=1&currency=EUR",
		      book_now: "RESERVA YA"
		    },

		    
		    {
		      title: "Iberia",
		      desc :"Gran variedad de vuelos económicos a Tel Aviv desde 249 EURO",
		      price : " 249€",
		      logo :"/Deals/iberia.png",
		      link :"https://www.iberia.com/vuelos-baratos/Madrid-Tel-Aviv/",
		      book_now: "RESERVA YA"
		    },

		    {
		      title: "Air Europa",
		      desc :"Gran variedad de vuelos económicos a Tel Aviv desde 250 EURO",
		      price : " 250€",
		      logo :"/Deals/aireuropa.png",
		      link :"https://www.aireuropa.com/es-es/ofertas-de-vuelos-desde-madrid-a-tel-aviv",
		      book_now: "RESERVA YA"
		    },


		    {
		      title: "Vueling",
		      desc :"Gran variedad de vuelos económicos a Tel Aviv desde 251 EURO",
		      price : " 251€",
		      logo :"/Deals/vueling.png",
		      link :"https://www.vueling.com/en/routes/cheap-flights-from-madrid-to-telaviv",
		      book_now: "RESERVA YA"
		    },
		      {
		      title: "NAUTALIA VIAJES",
		      desc :"VUELO + HOTEL A JERUSALÉN",
		      price : "257€",
		      logo :"/Deals/9.jpg",
		      link :"https://www.nautaliaviajes.com/vuelo-hotel/asia/israel/",
		      book_now: "RESERVA YA"
		    },
		    {
		      title: "El Al",
		      desc :"Vuele a Tel Aviv",
		      price : " 294€",
		      logo :"/Deals/elal.png",
		      link :"https://www.elal.com/Spain/Pages/default.aspx",
		      book_now: "RESERVA YA"
		    },

		    
		    {
		      title: "TEL AVIV HOTEL",
		      desc :"el sitio perfecto para una escapada urbana Cena gratuita para dos personas",
		      price : " 120€",
		      logo :"/Deals/tlv-hotels.png",
		      link :"https://www.visit-tel-aviv.com/en/promotions/telaviv",
		      book_now: "RESERVA YA"
		    },

		    {
		      title: "MAPA DINAMICS",
		      desc :"JERUSALÉN",
		      price : " 478€",
		      logo :"/Deals/mapa.jpg",
		      link :"https://www.mapadinamics.com/idea/454826/jerusalen",
		      book_now: "RESERVA YA"
		    },
		    {
		      title: "Travelplan",
		      desc :"ESTANCIA EN TELAVIV",
		      price : " 485€",
		      logo :"/Deals/20.jpg",
		      link :"http://www.travelplan.es/b2b/html/pub/catalogos_xml/new_contenedor_virtual.html?catalogo=2019_2020/isj1920&numpagina=18",
		      book_now: "RESERVA YA"
		    },

		    {
		      title: "Logitravel",
		      desc :"TEL AVIV",
		      price : "535€",
		      logo : "/Deals/10.jpg",
		      link :"https://www.logitravel.com/viajes/asia/israel/",
		      book_now :"RESERVA YA"
		    },
		    


		    {
		      title: "LUXOTOUR",
		      desc :"Escapada a Jerusalén y alrededores",
		      price : " 565€",
		      logo :"/Deals/28.png",
		      link:"https://www.luxotour.es/reservar/escapada-jerusalen-y-alrededores-20_-5122?search_date=",
		      book_now:"RESERVA YA"
		    },
		    

		    {
		      title: "Travelplan",
		      desc :"ESTANCIAS EN JERUSALÉN",
		      price : " 599€",
		      logo :"/Deals/20.jpg",
		      link :"http://www.travelplan.es/b2b/html/pub/catalogos_xml/new_contenedor_virtual.html?catalogo=2019_2020/isj1920&numpagina=20",
		      book_now: "RESERVA YA"
		    },


		    {
		      title: "Tourist Forum",
		      desc :"Escapada a Israel",
		      price : "631€",
		      logo  :"/Deals/turist-forum.jpg",
		      link   : "https://www.touristforum.net/escapada-israel-telaviv-jerusalen?utm_source=GoIsrael&utm_medium=web&utm_campaign=Israel",
		      book_now :"RESERVA YA"
		    },
		    
		    
		    {
		      title: "Viajes El Corte Inglés",
		      desc :"DESCUBRE ISRAEL",
		      price : "681€",
		      logo :"/Deals/31.png",
		      link :"https://transporte-hotel.viajeselcorteingles.es/idea/236369/descubre-israel?tripId=0",
		      book_now: "RESERVA YA"
		    },
		   

		    {
		      title: "Dynamic Tours",
		      desc :"ESTANCIA EN JERUSALÉN",
		      price : " 717€",
		      logo :"/Deals/16.jpg",
		      link :"https://www.dynamic-tours.com/detalle-oferta.php?oferta=110",
		      book_now :"RESERVA YA"
		    },
		    

		    {
		      title: "CATAI",
		      desc :"ESTANCIA EN JERUSALÉN",
		      price : "720€",
		      logo  :"/Deals/5.jpg",
		      link   : "https://www.catai.es/viajes/estancia-en-jerusalen.html/13922/travelpricer",
		      book_now :"RESERVA YA"
		    },

		    {
		      title: "Tarawa Travel",
		      desc :"PLAYAS DE TEL AVIV",
		      price : " 740€",
		      logo:"/Deals/17.jpg",
		      link:"https://www.tarawatravel.com/Viaje/Israel-Playas-de-Tel-Aviv/28-2596",
		      book_now:"RESERVA YA"
		    },
		    {
		      title: "TOURIST FORUM",
		      desc :"Escapada a Jerusalén",
		      price : "749€",
		      logo : "/Deals/turist-forum.jpg",
		      link: "https://www.touristforum.net/escapada-israel-jerusalen?utm_source=GoIsrael&utm_medium=web&utm_campaign=Jerusalen",
		      book_now :"RESERVA YA"
		    },
		     {
		      title: "WORLD TRAVEL BITAKORA",
		      desc :"ESCAPADA A JERUSALÉN",
		      price : " 762€",
		      logo :"/Deals/bikatora.png",
		      link:"https://www.wtbitakora.com/Circuitos/Detalle?ProductCode=OM0250&BrochureNumber=167&ProductCode=OM0250&BrochureNumber=167",
		      book_now:"RESERVA YA"
		    },

		    {
		      title: "Travelplan",
		      desc :"COMBINADO TELAVIV Y <br>JERUSALÉN MÁGICOS",
		      price : " 799€",
		      logo :"/Deals/20.jpg",
		      link :"http://www.travelplan.es/b2b/html/pub/catalogos_xml/new_contenedor_virtual.html?catalogo=2019_2020/isj1920&numpagina=32",
		      book_now: "RESERVA YA"
		    },

		    {
		      title: "Girovolt Viatges",
		      desc :"DESCUBRIENDO TEL AVIV Y JERUSALÉN",
		      price : " 821€",
		      logo :"/Deals/11.jpg",
		      link:"http://www.viatgesgirovol.com/?msgOrigen=6&CODART=ART02539",
		      book_now:"RESERVA YA"
		    },

		   

		    {
		      title: "Tarawa Travel",
		      desc :"JERUSALÉN CLÁSICO",
		      price : " 825€",
		      logo :"/Deals/17.jpg",
		      link :"http://www.tarawatravel.com/Viaje/Jerusalen-Clasico/28-2059/",
		      book_now: "RESERVA YA"
		    },

		   

		    {
		      title: "Viatges Travelling",
		      desc : "TEL AVIV GAY",
		      price: " 940€",
		      logo: "/Deals/12.jpg",
		      link :"http://viatgestravelling.com/destino/tel-aviv-gay/ ",
		      book_now :"RESERVA YA"
		    },

		   
		     {
		      title: "TUI SPAIN",
		      desc :"Jerusalén Soñado",
		      price : " 1039€",
		      logo : "/Deals/3.jpg",
		      link: "https://es.tui.com/Viajes/Ficha?CodigoProducto=AOA19IL83&NumeroFolleto=1221",
		      book_now :"RESERVA YA"
		    },

		    {
		      title: "TUI SPAIN",
		      desc :"Telaviv y Jerusalén. 6 días ",
		      price : " 1094€",
		      logo : "/Deals/3.jpg",
		      link: "https://es.tui.com/Viajes/Ficha?CodigoProducto=A0A19IL84&NumeroFolleto=1221",
		      book_now :"RESERVA YA"
		    },

		    {
		      title: "VIAJES PRÓXIMO ORIENTE",
		      desc :"Escapada a Jerusalén",
		      price : " 1259€",
		      logo  :"/Deals/11b.png",
		      link   : "https://www.viajesproximoriente.com/circuito/10-escapada-a-jerusalen",
		      book_now :"RESERVA YA"
		    }

	

  	]

  }

  render() {

  	const dealsHtml = this.deals.map((o)=>{
  		return <DealItem 
  					brand={ o.title } 
  					price={ o.price } 
  					brandImg={ o.logo } 
  					desc={ o.desc } 
  					bookNowLink={o.link}
  					descFontSize={ o.fontSize }
				/>
  	})
    return (
	      <div className="deals-wrapper">
        	<SimpleSlider settings={this.dealsSliderSettings}>
	           {dealsHtml}
          	</SimpleSlider>
	      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js